// @flow

import useAllServicesLoader from './useAllServicesLoader';

import { type Node } from 'react';

import type { ServiceLoaderResults } from './types';

type Props = {
  // If `false` this will filter out private service results from the child.
  // It does not prevent the private service request from occuring.
  includePrivate: boolean,
  children: (results: ServiceLoaderResults) => Node,
};

/**
 * Provide all services via render prop.
 * DEPRECATED - use `AllServicesProvider` and `useAllServices` hook instead.
 */
const WithAllServices = ({ includePrivate, children }: Props) =>
  children(useAllServicesLoader({ includePrivate }));

WithAllServices.defaultProps = { includePrivate: true };

export default WithAllServices;
